import { createStore } from 'vuex';

import auth from './auth';
import createAccount from './createAccount';
import news from './news';
import policy from './policy';
import document from './document';
import config from './config';

import collectivity from './collectivity';
import download from './download';
import user from './user';
import faqs from './faqs';
import financialSummary from './financialSummary';
import agreement from './agreement';
import customer from './customer';
import insuranceCard from './insuranceCard';
import declaration from './declaration';
import invoice from './invoice';
import contactForm from './contactForm';
import contract from './contract';
import notification from './notification';
import addInsured from './addInsured';
import memberOffers from './memberOffers';
import menu from './menu';
import tile from './tile';
import insuranceRight from './insuranceRight';
import careMediation from './careMediation';
import treatmentAbroad from './treatmentAbroad';
import seatedPatientTransport from './seatedPatientTransport';
import requestEditPolicySurvey from './requestEditPolicySurvey';

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Store instance.
 */
export const store = createStore({
  modules: {
    auth,
    createAccount,
    news,
    policy,
    document,
    config,
    collectivity,
    download,
    user,
    faqs,
    financialSummary,
    agreement,
    customer,
    insuranceCard,
    declaration,
    invoice,
    contactForm,
    contract,
    notification,
    addInsured,
    memberOffers,
    menu,
    tile,
    insuranceRight,
    careMediation,
    treatmentAbroad,
    seatedPatientTransport,
    requestEditPolicySurvey,
  },

  // enable strict mode (adds overhead!)
  // for dev mode only
  strict: process.env.DEV,
});

export default function (/* { ssrContext } */) {
  return store;
}
